import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { getCookie } from '../../utils/utils'; 

const ProtectedFeatureRoute = ({ exact, path, component }) => {
    let location = useLocation();

    return !JSON.parse(getCookie('routeOptions')).some(routeOpt => location.pathname.startsWith(routeOpt.path)) ? (
        <Redirect from={path} to={'/search'} exact />
    ) : (
        <Route exact={exact} path={path} component={component}/>
    );
};

export default ProtectedFeatureRoute;